export default {
  Operator: 'operator',
  Supplier: 'supplier',
}
